{
  "buttons": {
    "save": "Save",
    "cancel": "Cancel"
  },
  "navbar": {
    "skipToNavigation": "Skip to navigation",
    "cart": "Cart",
    "navigation": "Navigation"
  }
}
